"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = OSWApptInfo;
var _react = _interopRequireDefault(require("react"));
var _xstate = require("xstate");
var _react2 = require("@xstate/react");
var _propTypes = require("prop-types");
var _Banners = require("../Banners");
var _utils = require("../../lib/utils");
var _configUtils = require("../../lib/configUtils");
var _States = require("../../lib/constants/States");
var _EpicOSW = require("../../lib/constants/EpicOSW");
var _propTypes2 = require("../../lib/propTypes");
function OSWApptInfo(_ref) {
  let {
    service,
    config
  } = _ref;
  const [state] = (0, _react2.useService)(service);
  const {
    provider,
    epicOSWConfig,
    externalID,
    visitType
  } = state.context;
  /**
   * Setting phone to empty string here will take care of displaying an alternate banner without a phone number.
   */
  const phone = (0, _configUtils.shouldHideSchedulingHelpMessages)(config) ? '' : (0, _utils.getMainContactNumber)(provider);
  if (state.matches(_States.error)) {
    return /*#__PURE__*/_react.default.createElement("div", {
      "data-testid": "OSWApptInfo"
    }, /*#__PURE__*/_react.default.createElement(_Banners.ErrorBookingBanner, {
      phone: phone
    }));
  }
  if (state.matches(_States.success)) {
    const iFrameURL = epicOSWConfig.open_scheduling_host;
    const iFrameURLParams = `?id=${externalID}&vt=${visitType}`;
    return /*#__PURE__*/_react.default.createElement("div", {
      "data-testid": "OSWApptInfo"
    }, /*#__PURE__*/_react.default.createElement("link", {
      href: epicOSWConfig.open_scheduling_css_url,
      rel: "stylesheet",
      type: "text/css"
    }), /*#__PURE__*/_react.default.createElement("div", {
      id: "scheduleContainer"
    }, /*#__PURE__*/_react.default.createElement("iframe", {
      title: _EpicOSW.IFRAME_TITLE,
      id: "openSchedulingFrame",
      className: "widgetframe",
      scrolling: "no",
      src: `${iFrameURL}${iFrameURLParams}`,
      "data-oswstep": "0",
      onLoad: () => {
        window.EWC = new window.EmbeddedWidgetController({
          hostname: epicOSWConfig.open_scheduling_hostname,
          // Must equal media query in EpicWP.css + any left/right margin of the host page.
          // Should also change in EmbeddedWidget.css
          matchMediaString: '(max-width: 747px)',
          //Show a button on top of the widget that lets the user see the slots in fullscreen.
          showToggleBtn: true
        });
      }
    })));
  }
  return null;
}
const propTypes = {
  /**
   * The machine that maintains state and context for the component
   */
  service: (0, _propTypes.instanceOf)(_xstate.Interpreter).isRequired,
  config: _propTypes2.configType
};
OSWApptInfo.propTypes = propTypes;
OSWApptInfo.defaultProps = {
  config: {}
};
OSWApptInfo.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "OSWApptInfo",
  "props": {
    "config": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "custom",
        "raw": "configType"
      },
      "required": false
    },
    "service": {
      "description": "The machine that maintains state and context for the component",
      "type": {
        "name": "instanceOf",
        "value": "Interpreter"
      },
      "required": true
    }
  }
};